import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';

import Modal from 'components/Modal';
import Button from 'components/Button';
import FormInput from 'components/FormInput';
import FormSelect from 'components/FormSelect';
import { useHomeScreenContext } from 'layouts/HomeScreenLayout/contexts/HomeScreenContext';
import { components } from 'react-select'; // Import components
import { useGroupFringeQuery } from 'utils/api/queries';
import CreateGroups from 'components/CreateGroups';

// import './styles.scss';
import './styles.scss';
import PropTypes from 'prop-types';
import { toastStyle } from 'utils/helper';

const EditFringe = props => {
  const [groupOptions, setGroupOptions] = useState([]); // State for groups
  const {
    updateFrindeMutation,
    refetchFringe,
    hideUpdateFringeModal,
    selectTab,
    clearBudgetRename,
    refetchFringeId,
    setshowCreateGroupsModal,
    showCreateGroupsModal,
    activeBudget,
    hasEditAccess,
  } = useHomeScreenContext();
  const isGroupJustCreatedRef = useRef(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const instanceType = queryParams.get('type') || 'budget';
  const { data: budget_details, refetch } =
    useGroupFringeQuery.useGroupFringeDetailsQuery({
      filters: {
        instance_type: instanceType,
        active_id: activeBudget,
      },
      enabled: true,
    });

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    reset,
    watch,
    setValue,
  } = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: {
      name: props?.frineName || '',
      display_name: props?.fringeDisplay || '',
      id: props?.fringeId,
      description: props?.fringeDescription || '',
      abbreviation: props?.fringeAbbreviation || '',
      fringe_type: props?.fringeType || '',
      value: props?.fringeValue || '',
      base_cap: props?.fringeBaseCap || '',
      cap_on_total: props?.fringeCapOnTotal || '',
      group: [],
    },
  });

  const handleGroupCreated = newGroup => {
    const newGroupOption = { value: newGroup.id, label: newGroup.name };
    setGroupOptions(prev => [...prev, newGroupOption]);
    const currentSelected = watch('group') || [];
    const updatedSelected = [...currentSelected, newGroupOption];
    setValue('group', updatedSelected, { shouldValidate: true });
    isGroupJustCreatedRef.current = true;
    setshowCreateGroupsModal(false);
  };

  // const handleGroupCreated = newGroup => {
  //   const newGroupOption = { value: newGroup.id, label: newGroup.name };

  //   // Add the new group to groupOptions for the dropdown
  //   setGroupOptions(prev => [...prev, newGroupOption]);

  //   // Append the new group to the current selected groups in the form
  //   const currentSelected = watch('group') || [];
  //   const updatedSelected = [...currentSelected, newGroupOption];
  //   setValue('group', updatedSelected, { shouldValidate: true });

  //   // Update the fringeGroup in the parent component
  //   props.setfringeGroup(prevFringeGroup => {
  //     const existingGroups = prevFringeGroup
  //       ? prevFringeGroup.split(',').map(lbl => lbl.trim())
  //       : [];
  //     if (!existingGroups.includes(newGroup.name)) {
  //       const updatedGroups = [...existingGroups, newGroup.name];
  //       return updatedGroups.join(', ');
  //     }
  //     return prevFringeGroup; // No change if the group already exists
  //   });

  //   // Close the create group modal
  //   setshowCreateGroupsModal(false);
  // };

  useEffect(() => {
    if (budget_details?.data?.data && !isGroupJustCreatedRef.current) {
      const allGroups = budget_details.data.data.map(g => ({
        label: g.name,
        value: g.id,
      }));
      setGroupOptions(allGroups);
      if (props.fringeGroup) {
        const groupLabels = props.fringeGroup.split(',').map(lbl => lbl.trim());
        const matchedGroups = allGroups.filter(opt =>
          groupLabels.includes(opt.label)
        );
        setValue('group', matchedGroups);
      }
    }
    isGroupJustCreatedRef.current = false;
  }, [budget_details, props.fringeGroup, setValue]);

  const CustomMultiValue = ({ data, removeProps }) => {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          background: '#E5E4E2',
          padding: '5px 8px',
          margin: '2px',
          borderRadius: '2px',
          fontSize: '14px',
        }}
      >
        {data.label}
        <span
          {...removeProps}
          style={{
            marginLeft: '8px',
            cursor: 'pointer',
            color: 'red',
          }}
        >
          ×
        </span>
      </div>
    );
  };

  // ✅ Add PropTypes validation
  CustomMultiValue.propTypes = {
    data: PropTypes.shape({
      label: PropTypes.string.isRequired, // Ensure `label` is validated
    }).isRequired,
    removeProps: PropTypes.object.isRequired, // Since `removeProps` is an event handler
  };

  const CustomMenuList = ({ children, ...rest }) => {
    return (
      <components.MenuList {...rest}>
        {children}
        <div
          style={{
            padding: '8px',
            textAlign: 'center',
            cursor: 'pointer',
            backgroundColor: '#f8f9fa',
            borderTop: '1px solid #e9ecef',
          }}
          onClick={() => setshowCreateGroupsModal(true)} // Open modal on click
        >
          + Add Group
        </div>
      </components.MenuList>
    );
  };
  CustomMenuList.propTypes = {
    children: PropTypes.node.isRequired, // Validate children
  };

  const handleCreateBudget = () =>
    handleSubmit(async data => {
      try {
        const response = await updateFrindeMutation.mutateAsync({
          name: data.name,
          description: data.description,
          abbreviation: data.abbreviation,
          display_name: data.display_name,
          type: data.fringe_type,
          value: String(data.value),
          base_cap: String(data.base_cap),
          cap_on_total: String(data.cap_on_total),
          id: props?.fringeId,
          instance_type: instanceType,
          group: Array.isArray(data.group)
            ? data.group.map(groupItem => groupItem.label)
            : [],
        });
        const newBudget = response?.data;
        newBudget?.id && selectTab(newBudget.id, newBudget);
        refetchFringe?.();
        refetchFringeId?.();
        toast.success(`Fringe updated successfully`, toastStyle);
        reset();
        handleCancel();
        props?.refetch();
        // window?.location?.reload();
      } catch (error) {
        let message =
          'An error occurred while updating the budget. Please try again later.';

        if (error?.response?.data) {
          const responseData = error.response.data;

          // Handling abbreviation-specific error
          if (responseData?.abbreviation) {
            message = responseData.abbreviation;
          }
          // Handling other specific errors (e.g., name)
          else if (responseData?.name) {
            message = responseData.name[0];
          }
          // Handle general errors like non_field_errors
          else if (responseData?.non_field_errors?.length) {
            message = responseData.non_field_errors.join(', ');
          }
          // Fallback if no specific error is found
          else if (typeof responseData === 'string') {
            message = responseData;
          }
        }

        toast.error(message, toastStyle);
      }
    });

  const handleCancel = () => {
    hideUpdateFringeModal();
    clearBudgetRename();
    reset();
    props?.closeFolder();
  };

  // when i try to update the fringe without changing the group it sends back group name instead of group id
  return (
    <>
      <Modal
        onHide={handleCancel}
        show={props?.showCreateFringeModal}
        size="md"
        className="create-budget"
        bodyClass="create-budget__body"
        centered={true}
      >
        <h1 className="create-budget__body__header">
          Edit Fringe{' '}
          {watch('name') && (
            <span className="budget-name">&ldquo;{watch('name')}&rdquo;</span>
          )}
        </h1>
        <Form className="overflow-hidden" onSubmit={handleCreateBudget()}>
          <FormInput
            label="Fringe Name"
            type="text"
            error={errors?.name?.message}
            placeholder="Please enter a budget title"
            autoFocus
            {...register('name', {
              required: 'Fringe name is required',
              validate: value =>
                value.trim() !== '' || 'Fringe name cannot be just spaces',
            })}
            disabled={instanceType === 'budget' && !hasEditAccess()}
          />
          <FormInput
            label="Fringe Display Name"
            type="text"
            error={errors?.display_name?.message}
            placeholder="Please enter a short name"
            {...register('display_name', {
              required: 'Fringe display name is required',
              validate: value =>
                value.trim() !== '' ||
                'Fringe display name cannot be just spaces',
            })}
            disabled={instanceType === 'budget' && !hasEditAccess()}
          />
          <FormInput
            label="Fringe Description"
            type="textarea"
            error={errors?.description?.message}
            placeholder="Please provide the description"
            {...register('description')}
            disabled={instanceType === 'budget' && !hasEditAccess()}
          />
          <FormInput
            label="Fringe Letter Abbreviation"
            type="text"
            error={errors?.abbreviation?.message}
            placeholder="Please enter fringe abbreviation"
            {...register('abbreviation', {
              required: 'Fringe abbreviation is required',
              validate: value =>
                value.trim() !== '' ||
                'Fringe abbriviation cannot be just spaces',
              maxLength: {
                value: 5,
                message: 'Abbreviation cannot exceed 5 letters',
              },
            })}
            disabled={instanceType === 'budget' && !hasEditAccess()}
          />
          <div className="toggle-button-fringes">
            <label className="Type-button">Type</label>
            <div className="toggle-button-fringe">
              <Button
                label="Percentage"
                className={`toggle-button-one ${
                  watch('fringe_type') === 'percentage' ? 'active' : ''
                }`}
                onClick={() => setValue('fringe_type', 'percentage')}
                variant={
                  watch('fringe_type') === 'percentage'
                    ? 'primary'
                    : 'secondary'
                }
                isDisabled={instanceType === 'budget' && !hasEditAccess()}
              />
              <Button
                label="Flat Fee"
                className={`toggle-button-one ${
                  watch('fringe_type') === 'flat fee' ? 'active' : ''
                }`}
                onClick={() => setValue('fringe_type', 'flat fee')}
                variant={
                  watch('fringe_type') === 'flat fee' ? 'primary' : 'secondary'
                }
                isDisabled={instanceType === 'budget' && !hasEditAccess()}
              />
            </div>
            {errors?.fringe_type && (
              <p className="error-message">{errors.fringe_type.message}</p>
            )}
          </div>
          <FormInput
            label="Value"
            type="text"
            error={errors?.value?.message}
            placeholder="Please enter a value"
            {...register('value', {
              required: 'Value is required',
              validate: value => {
                const inputValue = String(value); // Force value to become a string
                if (inputValue.trim() === '') {
                  return 'Field cannot be just spaces';
                }
                return true;
              },
              pattern: {
                value:
                  /^(?!.*[a-zA-Z])(?=.*\d)[0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+$/,
                message:
                  'Only numbers and special characters are allowed (no letters)',
              },
            })}
            disabled={instanceType === 'budget' && !hasEditAccess()}
          />
          <FormInput
            label="Base Cap"
            type="text"
            error={errors?.base_cap?.message}
            placeholder="Please enter a value"
            {...register('base_cap', {
              pattern: {
                value:
                  /^(?!.*[a-zA-Z])(?=.*\d)[0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+$/,
                message:
                  'Only numbers and special characters are allowed (no letters)',
              },
            })}
            disabled={instanceType === 'budget' && !hasEditAccess()}
          />
          <FormInput
            label="Cap on Total"
            type="text"
            error={errors?.cap_on_total?.message}
            placeholder="Please enter a value"
            {...register('cap_on_total', {
              pattern: {
                value:
                  /^(?!.*[a-zA-Z])(?=.*\d)[0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+$/,
                message:
                  'Only numbers and special characters are allowed (no letters)',
              },
            })}
            disabled={instanceType === 'budget' && !hasEditAccess()}
          />
          <div className="group-select-container">
            <FormSelect
              label="Group(s)"
              placeholder={
                watch('group')?.length ? '' : 'Please select a Group'
              }
              options={groupOptions}
              error={errors?.group?.message}
              name="group"
              control={control}
              className="mb-5"
              isMulti={true}
              menuPlacement="top"
              menuPortalTarget={document.body}
              components={{
                MenuList: CustomMenuList,
                MultiValue: CustomMultiValue, // Add custom chip styling
              }} // Ensures proper rendering in modal
              styles={{
                menuPortal: base => ({ ...base, zIndex: 9999 }), // Ensure dropdown is not hidden
                menu: base => ({
                  ...base,
                  Height: '200px', // Limit height
                  overflowY: 'auto', // Enable scrolling
                }),
                menuList: base => ({
                  ...base,
                  maxHeight: '200px', // Ensure scrolling works
                  overflowY: 'auto',
                }),
                control: base => ({
                  ...base,
                  minHeight: '40px', // Adjust as needed
                }),
              }}
              isDisabled={instanceType === 'budget' && !hasEditAccess()}
            />
          </div>

          <div className="create-budget__body__action">
            <Button
              label="Cancel"
              type="reset"
              className="create-budget__action__cancel"
              variant="red-outlined"
              onClick={handleCancel}
            />
            <Button
              label="Confirm"
              className="create-budget__action__confirm"
              type="submit"
              isDisabled={instanceType === 'budget' && !hasEditAccess()}
            />
          </div>
        </Form>
      </Modal>
      {showCreateGroupsModal && (
        <CreateGroups
          closeFolder={() => {
            setshowCreateGroupsModal(false); // Close modal
            refetch(); // Refetch groups after creating a new one
          }}
          showCreateGroupsModal={showCreateGroupsModal}
          refetch={refetch}
          onGroupCreated={handleGroupCreated} // Pass the callback
        />
      )}
    </>
  );
};

EditFringe.propTypes = {
  parentid: PropTypes.string, // Assuming parentid is a string, adjust the type accordingly
  fringeId: PropTypes.string,
  showCreateFringeModal: PropTypes.bool,
  frineName: PropTypes.string,
  BudgetTypeData: PropTypes.string,
  closeFolder: PropTypes.func,
  refetch: PropTypes.func.isRequired, // Adjust the type based on the actual type of refetch
  fringeDescription: PropTypes.string,
  fringeAbbreviation: PropTypes.string,
  fringeDisplay: PropTypes.string,
  fringeType: PropTypes.string,
  fringeValue: PropTypes.string,
  fringeCapOnTotal: PropTypes.string,
  fringeBaseCap: PropTypes.string,
  fringeGroup: PropTypes.string,
};

EditFringe.defaultProps = {
  fringeId: '',
  parentid: '', // Default value for parentid (adjust based on actual default)
  showCreateFringeModal: false, // Default value for showAddFolder (adjust based on actual default)
  closeFolder: undefined,
  frineName: '',
  BudgetTypeData: '',
  fringeDescription: '',
  fringeAbbreviation: '',
  fringeDisplay: '',
  fringeType: '',
  fringeValue: '',
  fringeBaseCap: '',
  fringeCapOnTotal: '',
  fringeGroup: '',
};

export default EditFringe;
